<template>
  <div>
    <div class="conList" v-for="(item, i) in postList" :key="i" @mouseenter="enter(item)" @mouseleave="leave">
      <div :class="[{cLeft:true},{cLeft2:!item.questionCover}]" @click="toPostDetail(item)">
        <div class="title">
          <a href="javascript:;" :title="item.questionTitle">{{ item.questionTitle }}</a>
        </div>
        <div class="con" :title="item.questionAbstract">{{ item.questionAbstract }}</div>
        <div class="bottom">
          <div class="bottomL">
            <div class="img">
              <img :src="item.questionSendAvatar" alt="" />
            </div>
            <div>{{ item.questionSendName }}</div>
            <div class="time">{{ item.updateTime }}</div>
          </div>
          <div class="bottomR">
            <div class="bottomRItem"><Icon type="ios-chatboxes-outline" size="14" />{{ item.answerCount }}条评论</div>
            <div class="bottomRItem"><Icon type="ios-eye-outline" size="20" />{{ item.viewCount }}条查看</div>
            <div class="bottomRItem"><Icon type="ios-thumbs-up-outline" size="14" />{{ item.likeCount }}条点赞</div>
          </div>
        </div>
      </div>
      <div class="cRight" v-if="item.questionCover">
        <img :src="item.questionCover" alt="" />
      </div>
      <a href="javascript:;" class="delQuestion" v-if="item.questionSendUserId === userInfo.userId && isShowOperationBtn && currentId===item.id" @click="delQuestion(item)">删除</a>
    </div>
  </div>
</template>
<script>
import { getRequest } from '@/libs/axios'
export default {
  props: {
    postList: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      userInfo: {},
      isShowOperationBtn: false,
      currentId: ''
    }
  },
  mounted() {
    this.userInfo = this.$util.localGet('userInfo')
  },
  methods: {
    enter(item) {
      this.currentId = item.id
      this.isShowOperationBtn = true
    },
    leave() {
      this.isShowOperationBtn = false
    },
    toPostDetail(item) {
      this.$router.push({
        name: 'questionDetail',
        query: { id: item.id }
      })
    },
    async delQuestion(item) {
      this.$Modal.warning({
        title: '删除',
        content: `<p>确定删除此条问答？</p>`,
        closable: true,
        onOk: async () => {
          const res = await getRequest(`/v3/Community/teacher/deleteQuestion/${item.id}`)
          if (res.success) {
            this.$Message.success('删除成功')
            this.$emit('getQuestion')
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.conList {
  position: relative;
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding: .3rem 0.25rem 0.3rem;
  border-bottom: 0.01rem solid #ddd;
  .cLeft {
    width: 5.6rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-size: 0.18rem;
      color: #333;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
    }
    .con {
      font-size: 0.14rem;
      color: #999;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      margin: 0.1rem 0;
    }
    .bottom {
      display: inline-flex;
      align-items: center;
      font-size: 0.14rem;
      .bottomL {
        display: inline-flex;
        align-items: center;
        .img {
          width: 0.22rem;
          height: 0.22rem;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 0.06rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .time {
          font-size: 0.12rem;
          color: #999;
          margin-left: 0.06rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .bottomR {
        display: inline-flex;
        align-items: center;
        margin-left: 0.2rem;
        font-size: 0.12rem;
        color: #999;
        .bottomRItem {
          display: inline-flex;
          align-items: center;
          margin-right: 0.15rem;
          .ivu-icon {
            margin-right: 0.04rem;
          }
        }
      }
    }
  }
  .cLeft2{
    width: 100%;
  }
  .cRight {
    width: 1.9rem;
    height: 1.2rem;
    border-radius: 0.04rem;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .delQuestion {
    position: absolute;
    top: 0.05rem;
    right: 0.05rem;
    color: #df3d15;
  }
}
// .conList:last-child{
//     border-bottom: none;
// }
a:hover {
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/questionItem.vue